
import { Options, Vue } from 'vue-class-component';
import LegacyModal from '@/components/common/LegacyModal.vue';
import api from '@/shared/api';

interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    lastNamePrefix: string;
    isNewUser: boolean;
    setPasswordLink: string;
}

@Options({
    components: {
        Modal: LegacyModal,
    },
})
export default class AddUser extends Vue {
    private step = 'email';

    private newUserEmail = '';
    private setPasswordLink = ''

    //Create

    private async createUser() {
        const user: User = await api.addUserToBusinessUnit(this.newUserEmail);

        if (user.isNewUser) {
            this.setPasswordLink = user.setPasswordLink;
            this.step = 'userdetails';
        } else {
            this.$router.push({ name: 'manage-users' });
        }
    }

    protected cancelCreateUser() {
        this.$router.push({ name: 'manage-users' });
    }
}
